module.exports = __webpack_public_path__ + "static/media/IconPasswordOff.25e09ee6.svg";